import BModal from "@/components/singles/BModal/component.vue";
import BForm from "@/components/singles/BForm/component.vue";

export default {
  name: "",
  components: {
    BModal,
    BForm
  },
  props: ["billing"],
  data() {
    return {
      isLoading: false,
      showModal: false,
      firstLoadDone: false,
      billingForm: {
        valid: false,
        selects: [
          {
            name: "countries",
            nameProp: "name",
            title: "Country",
            selected: null,
            order: "name",
            validation: "required",
            items: []
          }
        ],
        inputs: [
          {
            name: "firstName",
            placeholder: "First name",
            type: "text",
            label: null,
            validation: "required|min:3",
            value: this.billing.firstName,
            focus: true
          },
          {
            name: "lastName",
            placeholder: "Last name",
            type: "text",
            label: null,
            value: this.billing.lastName,
            validation: "required|min:3"
          },
          {
            name: "company",
            placeholder: "Company name",
            type: "text",
            label: null,
            value: this.billing.company,
            validation: "required|min:3"
          },
          {
            name: "vat",
            placeholder: "VAT number",
            type: "text",
            label: null,
            validation: "min:3",
            value: this.billing.vat
          },
          {
            name: "streetAddress",
            placeholder: "Street address",
            type: "text",
            label: null,
            validation: "required|min:3",
            value: this.billing.streetAddress
          },
          {
            name: "postalCode",
            placeholder: "Postal code",
            type: "text",
            label: null,
            validation: "required|min:3",
            value: this.billing.postalCode
          }
        ]
      }
    };
  },
  computed: {},
  async created() {},
  async mounted() {},
  methods: {
    async Show() {
      this.$set(this, "showModal", true);
      this.showModal = true;
      await this.LoadCountries();
      this.SetCountry();
    },

    SetCountry() {
      this.billingForm.selects[0].selected = this.billingForm.selects[0].items.find(
        x => x.name === this.billing.country
      );
    },

    async Save() {
      this.SaveBefore();

      this.$helpers
        .PostApi("set/billing", {
          object: {
            firstName: this.billingForm.inputs[0].value,
            lastName: this.billingForm.inputs[1].value,
            company: this.billingForm.inputs[2].value,
            vat: this.billingForm.inputs[3].value,
            streetAddress: this.billingForm.inputs[4].value,
            postalCode: this.billingForm.inputs[5].value,
            country: this.billingForm.selects[0].selected.value
          }
        })
        .then(res => {
          this.SaveSuccessful(res);
        })
        .catch(err => {
          this.SaveError(err);
        });
    },
    SaveBefore() {
      this.isLoading = true;
    },
    SaveSuccessful(res) {
      this.$emit("saved");
      this.showModal = false;
      this.$helpers.ShowNotification("Saved", "success", 3000);

      this.isLoading = false;
    },
    SaveError(err) {
      this.isLoading = false;

      if (err.response.status === 400) {
        this.$helpers.ShowStatus(err.response.data, 10000, "warning");
      }
    },

    async LoadCountries() {
      if (this.billingForm.selects[0].items.length === 0) {
        this.billingForm.selects[0].items = (
          await this.$helpers.PostApi("get/countryList", {}, true)
        ).map(x => {
          return {
            name: x,
            value: x
          };
        });
      }
    }
  }
};
